import { render, staticRenderFns } from "./ImportPrices.vue?vue&type=template&id=65511789&scoped=true&"
import script from "./ImportPrices.vue?vue&type=script&lang=js&"
export * from "./ImportPrices.vue?vue&type=script&lang=js&"
import style0 from "./ImportPrices.vue?vue&type=style&index=0&id=65511789&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65511789",
  null
  
)

export default component.exports